function setCookie(cname, cvalue, exdays) {
  let d = new Date();
  d.setTime(d.getTime() + (exdays*24*60*60*1000));
  let expires = "expires="+ d.toUTCString();
  document.cookie = cname + "=" + cvalue + ";" + expires + ";path=/";
}

function getCookie(cname) {
  let name = cname + "=";
  let decodedCookie = decodeURIComponent(document.cookie);
  let x = decodedCookie.split(';');

  for(let i = 0; i < x.length; i++) {
    let c = x[i];
    while (c.charAt(0) == ' ') {
      c = c.substring(1);
    }
    if (c.indexOf(name) == 0) {
      return c.substring(name.length, c.length);
    }
  }
  return "";
}

function verifyUserDevice() {
    const toMatch = [
      /Android/i,
      /webOS/i,
      /iPhone/i,
      /iPad/i,
      /iPod/i,
      /BlackBerry/i,
      /Windows Phone/i
    ];

    return toMatch.some((toMatchItem) => {
      return navigator.userAgent.match(toMatchItem);
    });
}

function setBootstrapModal() {

  let closeButton = document.querySelector('#close-button');
  this.$closebutton = closeButton;

  let userAgentDevice = verifyUserDevice();
  console.log(userAgentDevice);

  let modal = getCookie("modal");
  let container  = document.querySelector('#modal') !== null;

  /*Check if modal cookie is set or not*/
  if (modal !== "") {
    /*if cookie is set lets hide the modal*/

    if (container) {
      document.querySelector('#modal').style.display = 'none';
    }
  }
  else {
    /*if cookie is not set lets show the modal for once*/

    if (container && userAgentDevice === true) {
      document.querySelector('#modal').style.display = 'block';

      this.$closebutton.addEventListener('click', ()=>{
        document.querySelector('#modal').style.display = 'none';
      });

      /**
       * setCookie(cname, cvalue, exdays)
       * cookie expires in 7 days
       */
      setCookie("modal", 'hide', 365);
    }
  }
}

/*
Calling to function
 */
setBootstrapModal();
